import { PRODUCT_TYPE } from '../../constants';

// eslint-disable-next-line import/prefer-default-export
export const setDeliveryStateHelper = (data, countryCode) => {
  const deliveries = data
    ? data.reduce((obj, line) => {
        const {
          lineId,
          recipientAddress,
          deliveryDate,
          deliveryMethod,
          giftcardValue,
          valueCurrency,
          recipientEmail,
          recipientName,
          recipientPhone,
          stockKeepingUnit,
        } = line;
        let address = {};
        if (recipientAddress !== null) {
          address = recipientAddress;
        } else {
          address = {
            attention: null,
            city: null,
            countryCode,
            line1: null,
            line2: null,
            postCode: null,
          };
        }
        return {
          ...obj,
          [lineId]: {
            deliveryDate,
            deliveryMethod,
            giftcardValue,
            valueCurrency,
            recipientName,
            recipientEmail,
            recipientPhone,
            stockKeepingUnit,
            ...address,
          },
        };
      }, {})
    : {};
  return deliveries;
};

export const getPhysicalProducts = (data, presentationData) =>
  data.filter(
    product =>
      presentationData[product.productId]?.productType ===
        PRODUCT_TYPE.physicalProduct && product,
  );

export const getDeliveryFees = data => {
  // To display the fees on basket level we need to:
  // 1. Map deliveryFees, filter them using relatedToProductLine on callback
  // 2. Add identifier field with recipient info to each delivery fee
  return data.flatMap(itm => {
    // Physical calculates delivery fees using Shipping quote so not needed here
    const identifierByDeliveryMethod = {
      DeliveryMethodEmail: 'recipientEmail',
      DeliveryMethodSms: 'recipientPhone',
    };

    return itm.fees
      .map(fee => ({
        ...fee,
        identifier: itm[identifierByDeliveryMethod[fee.lineId]],
      }))
      .filter(fee => fee.relatedToProductLine == null);
  });
};

export const getTotalDeliveryFees = data => {
  let feesTotal = 0;
  const fees = getDeliveryFees(data);
  if (fees.length > 0) {
    fees.forEach(
      // eslint-disable-next-line no-return-assign
      fee => (feesTotal += fee.totalPaymentAmountWithDiscountNoTax),
    );
  }

  return feesTotal;
};
export const getTotalTaxAmount = data => {
  let totalTax = 0;
  const fees = getDeliveryFees(data);
  if (fees.length > 0) {
    fees.forEach(
      // eslint-disable-next-line no-return-assign
      fee => (totalTax += fee.totalPaymentTaxAmount),
    );
  }

  return totalTax;
};
export const getTagManagerProducts = (basketData, presentationData) =>
  basketData?.map(product => {
    const {
      productTitle: title,
      presentations: { productTitle } = {},
    } = presentationData?.[product.productId];
    return {
      id: product.productId,
      name: productTitle || title,
      price: product.totalPriceWithDiscountNoTax,
      quantity: product.quantity,
    };
  });

export const getNumberFixedValue = (val, toFixedVal = 2) => {
  return val ? Number(val.toFixed(toFixedVal)) : val;
};
